"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = resourceHint;

function resourceHint(document, rel, url) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      asType = _ref.asType,
      crossorigin = _ref.crossorigin;

  var link = document.createElement('link');
  link.setAttribute('rel', rel);
  link.setAttribute('href', url);

  if (asType) {
    link.setAttribute('as', asType);
  }

  if (crossorigin) {
    link.setAttribute('crossorigin', '');
  }

  document.head.appendChild(link);
  return link;
}
//# sourceMappingURL=resourceHint.js.map